import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { BasePageComponent } from '../../base-page.component';
import { ActionPlanService, PeopleService } from '../../shared/services/index';
import { ActionPlanModel } from '../../shared/models/index';
import * as _ from 'lodash';
import { ActionPlanListMenuComponent } from '../../menus/action-plan-list.menu';

@Component({
    templateUrl: './list.component.html',
    standalone: false
})
export class ActionPlanListPageComponent extends BasePageComponent implements OnInit {
  public actionPlans: ActionPlanModel[];
  public peopleById: any = {};
  public loading: Boolean = true;

  constructor(
    public actionPlanService: ActionPlanService,
    private router: Router,
    private peopleService: PeopleService,
    location: Location
  ) {
    super(location);
  }

  ngOnInit() {
    this.actionPlanService.getActionPlans().subscribe((actionPlans: ActionPlanModel[]) => {
      this.actionPlans = actionPlans;
      this.peopleService.getPeople().subscribe((people) => {
        this.peopleById = _.keyBy(people, 'id');
        _.each(this.actionPlans, (ap: ActionPlanModel) => {
          if (ap.inspection && ap.inspection.getTechnicianId()) {
            ap.inspection.technician = this.peopleById[ap.inspection.getTechnicianId()];
            ap.inspection.technicianName = ap.inspection.technician != null ? ap.inspection.technician.name : '';
          }
        });
      });
      this.loading = false;
    });
  }

  public openMenu(): void {
    this.modal.modalFooter = false;
    this.modal.modalHeader = false;
    this.modal.modalMessage = false;
    this.modal.open(ActionPlanListMenuComponent);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        break;
      default:
    }
  }

  public openActionPlan(actionPlan: ActionPlanModel) {
    this.router.navigate([this.actionPlansRoute, actionPlan.id]);
  }

  goToBack(): void {
    this.router.navigate(['']);
  }
}
